import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

export const LDS_URL = 'http://localhost:12345';

export const ldsAxios = axios.create({
  baseURL: LDS_URL,
});

export class LDSHttpClient {
  private _api: AxiosInstance;

  public constructor() {
    this._api = ldsAxios;
  }

  public get = <T, R = T>(
    url: string,
    config?: AxiosRequestConfig,
  ): Promise<R> => {
    return this._api.get(url, config).then((x) => x.data);
  };

  public post = <T, R = T>(
    url: string,
    data: T,
    config?: AxiosRequestConfig,
  ): Promise<R> => {
    return this._api.post(url, data, config).then((x) => x.data);
  };
}
